var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "tag",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.clickHandler.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "ellipsis-1"
  }, [_vm._v(_vm._s(_vm.tag.name))])]);

}
var staticRenderFns = []

export { render, staticRenderFns }